import { createContext } from 'react';

export const ButtonContext = createContext('');
